<template>
  <div>
    <b-card>
      <div class="w-100 my-1 mb-2 float-left pl-1">
        <div class="d-flex align-items-center float-left">
          <!-- <a class="mr-50" @click="$router.go(-1)">
            <feather-icon icon="ChevronLeftIcon" size="20" />
          </a> -->
          <h3 class="m-0 font-weight-600">
            {{ appTitle || $t("services.title") }}
          </h3>
        </div>
        <div class="d-flex align-items-center flex-row-reverse">
          <b-button
            v-if="canCreate"
            v-b-modal.modal-create-services
            class="float-right mr-1"
            show-add
            variant="outline-primary"
          >
            {{ $t("services.create") }}
          </b-button>
          <widget-actions
            :show-add="false"
            :isSearchNeeded="false"
            item-type="services"
            :showMaximize="false"
            :show-filter="showfilter"
            @toggleFilters="toggleFilters"
            class="mr-2"
          />
        </div>
      </div>

      <template>
        <div
          v-if="areFiltersVisible"
          class="flex-column flex-md-row justify-content-center filters-container mb-2 px-50 pt-1"
        >
          <!-- Classifiers -->
          <div
            class="d-flex flex-column flex-md-row filters-container mb-2 px-50 pt-1"
          >
            <b-form-group
              :label="$t('filterType')"
              label-for="classifier-filter"
              class="mr-1 w-100"
            >
              <v-select
                v-model="selectedClassifiersForFilter"
                name="classifier-filter"
                clearable
                label="name"
                :reduce="(a) => a"
                :options="finalOptions"
                @input="setSeletedFilter"
              />
            </b-form-group>
            <!-- End Classifiers -->

            <!-- Custom -->
            <b-form-group
              v-if="nextFilter != null"
              label="Value"
              label-for="custom-filter"
              class="mr-1 w-100"
            >
              <v-select
                v-if="nextFilter[0] != null"
                v-model="selectedCustomFieldsForFilter"
                name="custom-filter"
                clearable
                label="name"
                :reduce="(nextFilter) => nextFilter"
                :options="nextFilter"
                @input="setSeletedFinalFilter"
              />

              <b-form-input
                v-if="nextFilter.type === 2"
                v-model="customFieldToSend[nextFilter.key]"
                placeholder="Start typing..."
                class="w-100"
                @keyup="handleChanger"
                @input="
                  setSeletedFinalFilter({
                    text: $event,
                    type: 2,
                    key: nextFilter.key,
                  })
                "
              />
            </b-form-group>
            <!-- End Custom -->
          </div>
        </div>
      </template>
      <!-- Loading -->
      <div v-if="isLoading">
        <b-spinner type="grow" small class="mx-auto mt-3 d-block" />
      </div>

      <!-- Container with data -->
      <div v-else-if="items.length > 0 && canView" class="cards-container">
        <div>
          <!-- Items Loop -->
          <service-card
            v-for="(item, index) in items"
            :key="index"
            :item="item"
          />
        </div>

        <!-- Load More items -->
        <div
          v-if="items.length < itemsData.meta.total"
          class="w-100 float-left"
        >
          <b-button
            v-if="!isLoadingNextPage"
            class="center-x my-3"
            variant="outline-primary"
            @click="handleLoadOfNewItems"
          >
            {{ $t("action.load-more") }}
          </b-button>
          <div v-else class="w-100">
            <b-spinner
              class="center-x my-3"
              small
              variant="primary"
              type="grow"
              label="Loading..."
            />
          </div>
        </div>
      </div>

      <!-- Container without data: Placeholder -->
      <b-row v-else class="horizontal-placeholder">
        <b-col cols="12">
          <img :src="servicesPlaceholder" />
        </b-col>
        <b-col cols="12">
          <p class="text-primary">
            {{ $t("available.message", { itemName: "items" }) }}
          </p>
        </b-col>
      </b-row>
    </b-card>
    <!-- Create Service -->
    <b-modal id="modal-create-services" centered hide-footer size="lg">
      <template #modal-header>
        <language-selector-header
          :title="$t('services.modal-create-title')"
          @closeModal="closeModal"
          @selectLanguage="(language) => (selectedLanguage = language)"
        />
      </template>
      <!-- Loading -->
      <membership-event-create-modal
        item-type="services"
        @close-modal="closeModal"
        :selected="selectedLanguage"
      />
    </b-modal>
  </div>
</template>

<script>
import ServicesPlaceholder from "@/assets/images/placeholders/light/projects.svg";
import ServicePlaceholder from "@/assets/images/placeholders/light/placeholder-dark.jpeg";
import { getImageResource } from "@/@core/utils/image-utils";
import FileTypes from "@/@core/constants/FileTypes";
import { checkPermissions } from "@/@core/utils/roles-utils";
import { translateTranslationTable } from "@/@core/libs/i18n/utils";
import WidgetActions from "@/@core/components/widget-actions/WidgetActions.vue";
import FileUpload from "@core/components/files/FileUpload.vue";
import FilePreview from "@core/components/files/FilePreview.vue";
import MembershipEventCreateModal from "@/views/apps/membershipEvents/components/MembershipEventCreateModal.vue";
import LanguageSelectorHeader from "@core/components/modal/LanguageSelectorHeader.vue";
import ServiceCard from "@/views/apps/services/components/ServiceCard.vue";
import vSelect from "vue-select";

export default {
  name: "ServicesList",
  components: {
    WidgetActions,
    FileUpload,
    FilePreview,
    MembershipEventCreateModal,
    LanguageSelectorHeader,
    ServiceCard,
    vSelect
  },
  data() {
    return {
      isLoading: true,
      isLoadingNextPage: false,
      lastLoadedPage: 1,
      loadingNext: false,
      serviceInput: {},
      formError: null,
      itemImage: null,
      imageSrc: null,
      showfilter: false,
      areFiltersVisible: false,
      nextFilter: null,
      selectedClassifiersForFilter: [],
      finalSelectClassifier: [],
      selectedLanguage: this.currentLocale,
    };
  },
  computed: {
    FileTypes() {
      return FileTypes;
    },
    // Load data from store
    itemsData() {
      return this.$store.getters.communitiesOthers.services;
    },
    items() {
      return this.itemsData.unpaginated;
    },
    collective() {
      return this.$store.getters.currentCollective;
    },
    servicePlaceholder() {
      return ServicePlaceholder;
    },
    servicesPlaceholder() {
      return ServicesPlaceholder;
    },
    currentCollective() {
      return this.$store.getters.currentCollective;
    },
    classifiers() {
      if (this.$store.getters.classifiers.services) {
        return this.$store.getters.classifiers.services.unpaginated;
      }
      return [];
    },
    sortedCommunityClassifiers() {
      const newObject = {};
      for (const item of this.classifiers) {
        if (
          !newObject[
            translateTranslationTable(
              this.$store.state.locale.currentLocale,
              item.typeName
            )
          ]
        ) {
          newObject[
            translateTranslationTable(
              this.$store.state.locale.currentLocale,
              item.typeName
            )
          ] = [item];
        } else {
          newObject[
            translateTranslationTable(
              this.$store.state.locale.currentLocale,
              item.typeName
            )
          ].push(item);
        }
      }
      const keys = Object.keys(newObject);
      const finalKeys = [];
      for (const row of keys) {
        finalKeys.push({
          key: row,
          name: row,
          type: 1,
        });
      }
      return [newObject, finalKeys];
    },
    finalOptions() {
      return [].concat(
        this.sortedCommunityClassifiers[1],
        this.customFieldsOptions
      );
    },
    canCreate() {
      return checkPermissions(
        "create",
        "service",
        this.loggedMemberRoles,
        this.currentCollective
      );
    },
    canView() {
      return checkPermissions(
        "index",
        "service",
        this.loggedMemberRoles,
        this.currentCollective
      );
    },
    loggedMemberRoles() {
      return this.$store.getters.loggedMemberRoles;
    },
    appId() {
      return 78;
    },
    app() {
      return this.$store.getters.apps.apps[this.appId];
    },
    appTitle() {
      return translateTranslationTable(
        this.$store.state.locale.currentLocale,
        this.app?.customizationName
      );
    },
    currentLocale() {
      return this.$store.state.locale.currentLocale;
    },
  },
  watch: {
    itemImage(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          this.base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value;
            })
            .catch(() => {
              this.imageSrc = null;
            });
        } else {
          this.imageSrc = null;
        }
      }
    },
  },
  // Fetch data when component is created!
  async created() {
    this.isLoading = true;
    this.updateBreadcrumbs();
    await this.fetchData(true);
    //await this.fetchCode();
    await this.fetchClassifiers();
    this.isLoading = false;
  },
  methods: {
    openModal() {
      this.$bvModal.show("modal-create-services");
    },
    closeModal() {
      this.$bvModal.hide("modal-create-services");
    },
    translate(field) {
      return translateTranslationTable(this.currentLocale, field);
    },
    updateBreadcrumbs() {
      this.$store.commit("app/SET_BREADCRUMBS", null);
    },
    //Filter Methods
    canFilter() {
      if (this.classifiers.length > 0) {
        this.showfilter = true;
      } else {
        this.showfilter = false;
      }
    },
    async fetchClassifiers() {
      this.isLoading = true;
      await this.$store.dispatch("getItems", {
        itemType: "backoffice/classifiers",
        storedKey: "services",
        customName: "classifiers",
        page: 1,
        requestConfig: {
          modelType: "services",
          count: 1000,
        },
      });
      this.canFilter();
    },
    toggleFilters() {
      this.areFiltersVisible = !this.areFiltersVisible;
      if (!this.areFiltersVisible) {
        this.customFieldToSend = {};
        this.finalSelectClassifier = [];
        (this.selectedCustomFieldsForFilter = null), (this.nextFilter = null);
        (this.total = 0),
          (this.filtersIndex = 0),
          (this.filters = []),
          (this.parentClassifiers = []),
          (this.selectedClassifiersForFilter = []);
        this.customFieldsInputs = [];
        this.index = 0;
        this.fetchData(true);
      }
    },
    async setSeletedFinalFilter(selected) {
      if (selected.type === 2) {
        this.customFieldToSend[selected.key] = selected.text;
      } else if (selected) {
        this.finalSelectClassifier = selected.key;
      } else {
        this.finalSelectClassifier = [];
      }
      this.handleChanger();
    },
    async setSeletedFilter(selected) {
      this.CustomFieldToSend = null;
      this.finalSelectClassifier = null;
      this.selectedCustomFieldsForFilter = null;
      this.nextFilter = null;
      if (selected.length === 0) {
        this.finalSelectClassifier = null;
      } else {
        let translated = [];
        if (selected.type === 1) {
          for (const row of this.sortedCommunityClassifiers[0][selected.key]) {
            translated.push({
              name: translateTranslationTable(
                this.$store.state.locale.currentLocale,
                row.name
              ),
              key: row.key,
              type: 1,
            });
          }
        } else if (selected.type === 2) {
          this.customFieldToSend[selected.key] = "";
          translated = {
            type: 2,
            key: selected.key,
          };
        }
        this.nextFilter = translated;
      }
    },
    handleChanger() {
      this.fetchData(true);
    },
    // End of filter Methods
    // TODO: move to utils
    base64Encode(data) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    // Call store action (with dispach) to load data from backend
    getImageSrc(url) {
      return getImageResource(url);
    },
    async fetchData(force = false) {
      await this.$store.dispatch("getItems", {
        itemType: "communities/simply",
        customName: "communitiesOthers",
        storedKey: "services",
        page: this.lastLoadedPage,
        forceAPICall: force,
        perPage: 30,
        requestConfig: {
          communityParentSlug: this.$store.getters.currentCollective.slug,
          orderByDate: -1,
          isService: true,
          classifiers: this.finalSelectClassifier,
          customFields:
            this.customFieldToSend != null &&
            Object.keys(this.customFieldToSend).length > 0
              ? this.customFieldToSend
              : null,
        },
      });
      this.isLoading = false;
    },
    // Load more items
    async handleLoadOfNewItems() {
      const { total } = this.itemsData.meta;
      if (!this.isLoading && this.items.length < total) {
        this.lastLoadedPage += 1;
        this.isLoadingNextPage = true;

        await this.fetchData(false);
        this.isLoadingNextPage = false;
      }
    },

    /*  async handleCreateItem(bvModalEvt) {
      // Name is required
      if (!this.serviceInput.name) {
        bvModalEvt.preventDefault();
        this.formError = false;
        return;
      }
      try {
        await this.$store.dispatch("createItem", {
          item: {
            itemType: "services",
            requestConfig: {
              name: this.serviceInput.name,
              unitPrice: this.serviceInput.unitPrice,
              headline: this.serviceInput.headline,
              description: this.serviceInput.description,
            },
          },
          file: this.imageSrc,
        });
        this.fetchData(true);
        this.serviceInput = {};
        this.formError = null;
        this.itemImage = null;
        this.imageSrc = null;
      } catch {
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: this.$t("error-message.general-error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    }, */
    updateBreadcrumbs() {
      const breadcrumbs = [
        {
          text: this.appTitle || this.$t("services.title"),
          active: true,
        },
      ];
      this.$store.commit("app/SET_BREADCRUMBS", breadcrumbs);
    },
  },
};
</script>
<style scoped>
.titulo {
  font-size: 1.2em;
}
.precio {
  padding-top: 12px;
  margin-bottom: 5px !important;
  font-size: 1.5em;
  font-weight: 900 !important;
}
.item-img {
  height: 200px !important;
}
.card-standard {
  height: 420px !important;
}
.card-text {
  margin-bottom: 2px !important;
}
/* TODO: fix responsive with bootstrap, better than media queries!! */
@media only screen and (max-width: 600px) {
  .cards-container {
    margin-left: -2rem;
  }
}
</style>
